import { Wrapper, CheckBox, CheckBoxCircle, Texts } from "./Terms.style.jsx";

const Terms = ({ checked, setChecked }) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const domain = baseUrl.split('api.')[1]?.split('/')[0];

  const handleClick = e => {
    e.stopPropagation();
    setChecked(s => !s);
  };

  return (
    <Wrapper onClick={() => setChecked(s => !s)}>
      <CheckBox onClick={e => handleClick(e)}>
        <CheckBoxCircle checked={checked} />
      </CheckBox>
      <Texts>
        <span>تمامی</span>
        <a
          onClick={e => e.stopPropagation()}
          href={`https://${domain}/license/`}
          target="_blank"
          rel="noreferrer"
          className="link-text"
        >
          قوانین و مقررات
        </a>
        و
        <a
          onClick={e => e.stopPropagation()}
          href={`https://${domain}/privacy-policy/`}
          target="_blank"
          rel="noreferrer"
          className="link-text"
        >
          سیاست حفظ حریم خصوصی
        </a>
        <span> استفاده از خدمات لندین را می‌پذیرم</span>
      </Texts>
    </Wrapper>
  );
};

export default Terms;
